import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react';
import SimpleBar from 'simplebar-react';
import PatientInfo from '../common/PatientInfo';
import BtnOutlineGradient from '../common/button/BtnOutlineGradient';
import { useNavigate } from 'react-router-dom';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction='left' ref={ref} {...props} />;
});
interface DialogDetailProps {
  open: boolean;
  onClose: () => void;
  patientDetail: any;
}

const DialogDetail: React.FC<DialogDetailProps> = (props) => {
  const navigate = useNavigate();
  const handleClose = () => {
    props.onClose();
  };

  const handleDetailClick = (patientid: string) => {
    navigate(`/patient/view?id=${patientid}`);
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      TransitionComponent={Transition}
      sx={{
        position: 'fixed !important',
        top: '0px !important',
        right: '0px !important',
        left: 'auto',
        bottom: 'auto',
        p: '0px',
        zIndex: 2147483647,
        '& .MuiDialog-paper': {
          m: '0px !important',
          width: '302px',
          height: '100vh',
          bgcolor: '#FAFDFF',
          borderRadius: '16px 0px 0px 16px',
        },
      }}
    >
      <DialogTitle id='scroll-dialog-title' sx={{ p: '5px 24px 0 0' }}>
        <Stack direction={'row'} justifyContent={'flex-end'}>
          <IconButton
            aria-label='toggle password visibility'
            edge='end'
            onClick={handleClose}
          >
            <Box
              component={'img'}
              src='/images/ic-close-blue.svg'
              alt='icon eye'
              sx={{ width: '24px', height: '24px' }}
            />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent
        sx={{
          p: '0px 24px 24px',
          '& .simplebar-track.simplebar-vertical .simplebar-scrollbar:before': {
            backgroundColor: '#CCD1D9',
          },
        }}
      >
        <BtnOutlineGradient
          text='患者詳細へ'
          handleButtonClick={() => handleDetailClick(props.patientDetail.id)}
          sx={{
            position: 'absolute',
            top: '50px',
            right: '20px',
            zIndex: 9
          }}
        />
        <SimpleBar
          style={{ height: 'calc(100vh - 69px)', borderWidth: '18px' }}
        >
          <Stack spacing='15px' height={'calc(100vh - 69px)'}>
            <PatientInfo patient={props.patientDetail} />
          </Stack>
        </SimpleBar>
      </DialogContent>
    </Dialog>
  );
};

export default DialogDetail;
